// // import React, { useState, useEffect } from "react";
// // import { useNavigate, Link } from "react-router-dom"; 
// // import config from "../../../Common/Configurations/APIConfig";
// // import apiService from "../../../Common/Configurations/APIService";
// // import Header from "../../../Common/Layout/Header";
// // import { useAuth } from "../../../Common/Configurations/AuthContext";
// // import Modal from "react-bootstrap/Modal";
// // import OutingChat from "./OutingChat"; 
// // import DefaultData from "../../../CompanyData/DefaultData";
// // import CorporateTabs from "../../AllTabs/CorporateTabs";

// // const initialFieldValues = {
// //   outingId: "00000000-0000-0000-0000-000000000000",
// //   destination: "",
// //   travelDate: new Date().toISOString().split('T')[0],
// //   teamSize: "",
// //   requirement: "",
// // };

// // const TeamOutingRequest = () => {
// //   const { user, loading } = useAuth();
// //   const navigate = useNavigate();

// //   const [btnLoading, setBtnLoading] = useState(false);
// //   const [lists, setLists] = useState([]);
// //   const [values, setValues] = useState(initialFieldValues);
// //   const [errors, setErrors] = useState({});
// //   const [addShow, setAddShow] = useState(false);
  
// //   // Requirement Pop-up States
// //   const [reqShow, setReqShow] = useState(false);
// //   const [reqContent, setReqContent] = useState("");

// //   const [totalPages, setTotalPages] = useState(0);
// //   const [pageSize, setPageSize] = useState(500); 
// //   const [pageNumber, setPageNumber] = useState(1);
// //   const [totalRecords, setTotalRecords] = useState(0);
// //   const [selectedOuting, setSelectedOuting] = useState(null); 

// //   // Fetch Data using ParentCompanyId for Admin view
// //   const GetData = async (pageNo) => {
// //     try {
// //       const res = await apiService.getAll(`${config.GETOUTINGSBYPARENTCOMPANYID}?parentCompanyId=${DefaultData.DEFAULTCOMPANYID}`, pageSize, pageNo);
// //       console.log("Fetched outings:", res);
// //       if (res && res.data) {
// //         setLists(res.data);
// //         setPageNumber(res.pageNumber);
// //         setTotalPages(res.totalPages);
// //         setTotalRecords(res.totalRecords);
// //       }
// //     } catch (error) { 
// //         console.error("Error fetching Admin outings:", error); 
// //     }
// //   };

// //   useEffect(() => { if (user && !loading) GetData(pageNumber); }, [user, loading]);

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setValues({ ...values, [name]: value });
// //   };

// //   const handleSelectOuting = (item) => setSelectedOuting(item);

// //   const handleShowFullRequirement = (e, text) => {
// //     e.stopPropagation();
// //     setReqContent(text);
// //     setReqShow(true);
// //   };

// //   const handleAddShow = () => {
// //     setValues(initialFieldValues);
// //     setAddShow(true);
// //   };

// //   const handleAddClose = () => { setAddShow(false); setErrors({}); };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setBtnLoading(true);
// //     const payload = { ...values, companyId: user?.cid, userId: user?.id, status: "Pending", outingId: "00000000-0000-0000-0000-000000000000" };
// //     try {
// //       await apiService.create(config.CREATEOUTING, payload);
// //       GetData(pageNumber);
// //       handleAddClose();
// //     } finally { setBtnLoading(false); }
// //   };

// //   if (loading) return <p>Loading ...</p>;

// //   return (
// //     <div id="layout-wrapper">
// //       <Header User={user} />
// //       <div className="main-content">
// //         <div className="page-content">
// //           <div className="container-fluid">
// //              <div className="p-2">
// //                 <CorporateTabs pageName="OUTINGREQUEST" />
// //               </div>
// //             <div className="p-4 mb-4 shadow-sm" style={{ background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)', borderRadius: '15px' }}>
// //                 <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
// //                     <div>
// //                         <h2 className="text-white fw-bold mb-1">Corporate Outing Management</h2>
// //                         <p className="text-white-50 fs-14 mb-0">Total Active Requests: <span className="text-warning fw-bold">{totalRecords}</span></p>
// //                     </div>
// //                     <button className="btn btn-warning px-4 fw-bold shadow" onClick={handleAddShow}>
// //                         <i className="ri-add-circle-line me-1"></i> LOG NEW INQUIRY
// //                     </button>
// //                 </div>
// //             </div>

// //             <div className="row">
// //                 {/* INQUIRY LIST (Left Side) */}
// //                 <div className={selectedOuting ? "col-lg-8" : "col-lg-12"}>
// //                     <div className="card border-0 shadow-sm overflow-hidden">
// //                         <div className="card-header bg-white py-3 border-bottom d-flex justify-content-between">
// //                             <h6 className="mb-0 fw-bold text-muted">Incoming Request Pipeline</h6>
// //                         </div>
// //                         <div className="table-responsive">
// //                             <table className="table align-middle mb-0 table-hover">
// //                                 <thead className="table-light text-uppercase fs-11">
// //                                     <tr>
// //                                         <th>Company Name</th>
// //                                         <th>Destination</th>
// //                                         <th>Pax</th>
// //                                         <th>Travel Date</th>
// //                                         <th>Status</th>
// //                                         <th className="text-center">Action</th>
// //                                     </tr>
// //                                 </thead>
// //                                 <tbody>
// //                                     {lists.map((item, i) => (
// //                                         <tr key={i} 
// //                                             onClick={() => handleSelectOuting(item)} 
// //                                             style={{ cursor: 'pointer' }}
// //                                             className={selectedOuting?.outingId === item.outingId ? "table-active border-start border-primary border-4" : ""}
// //                                         >
// //                                             <td>
// //                                                 <div className="fw-bold text-dark">{item.companyName}</div>
// //                                             </td>
// //                                             <td className="fw-bold text-primary">{item.destination}</td>
// //                                             <td><span className="badge bg-light text-dark border">{item.teamSize} pax</span></td>
// //                                             <td>{new Date(item.travelDate).toLocaleDateString('en-GB')}</td>
// //                                             <td>
// //                                                 <span className={`badge rounded-pill ${item.status === 'Pending' ? 'bg-soft-warning text-warning' : 'bg-soft-success text-success'}`}>
// //                                                     {item.status}
// //                                                 </span>
// //                                             </td>
// //                                             <td className="text-center">
// //                                                 <div className="d-flex justify-content-center gap-2">
// //                                                     <button className="btn btn-sm btn-soft-info" onClick={(e) => handleShowFullRequirement(e, item.requirement)}>
// //                                                         <i className="ri-eye-line"></i>
// //                                                     </button>
// //                                                     <button 
// //                                                         className={`btn btn-sm ${selectedOuting?.outingId === item.outingId ? 'btn-primary' : 'btn-soft-success'}`}
// //                                                         onClick={(e) => { e.stopPropagation(); handleSelectOuting(item); }}
// //                                                     >
// //                                                         <i className="ri-chat-3-line"></i>
// //                                                     </button>
// //                                                 </div>
// //                                             </td>
// //                                         </tr>
// //                                     ))}
// //                                 </tbody>
// //                             </table>
// //                         </div>
                        
// //                         <div className="card-footer bg-white border-top p-3">
// //                             <div className="d-flex justify-content-between align-items-center">
// //                                 <p className="text-muted mb-0 small">Showing {lists.length} of {totalRecords} Records</p>
// //                                 <ul className="pagination pagination-sm mb-0">
// //                                     <li className={`page-item ${pageNumber === 1 ? 'disabled' : ''}`}><button className="page-link" onClick={() => GetData(pageNumber - 1)}>Prev</button></li>
// //                                     <li className="page-item active"><span className="page-link">{pageNumber}</span></li>
// //                                     <li className={`page-item ${pageNumber === totalPages ? 'disabled' : ''}`}><button className="page-link" onClick={() => GetData(pageNumber + 1)}>Next</button></li>
// //                                 </ul>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>

// //                 {/* CHAT INTERFACE (Right Side) */}
// //                 {selectedOuting && (
// //                     <div className="col-lg-4">
// //                         <OutingChat 
// //                             outing={selectedOuting} 
// //                             user={user} 
// //                             senderType="Support" 
// //                             onClose={() => setSelectedOuting(null)} 
// //                         />
// //                     </div>
// //                 )}
// //             </div>
// //           </div>
// //         </div>

// //         {/* LOG MANUAL REQUEST MODAL (B2E Style) */}
// //         <Modal show={addShow} onHide={handleAddClose} centered size="lg" backdrop="static">
// //           <Modal.Header closeButton className="bg-light border-0 px-4">
// //             <Modal.Title className="fw-bold fs-18">Log Manual Inquiry</Modal.Title>
// //           </Modal.Header>
// //           <Modal.Body className="p-0">
// //             <div className="row g-0">
// //               {/* FORM SIDE */}
// //               <div className="col-md-7 p-4 border-end">
// //                 <form onSubmit={handleSubmit}>
// //                   <div className="mb-3">
// //                     <label className="form-label text-muted small fw-bold">DESTINATION / RESORT</label>
// //                     <input type="text" name="destination" className="form-control" value={values.destination} onChange={handleInputChange} placeholder="E.g. Luxury Palms Resort, Goa" required />
// //                   </div>
// //                   <div className="row mb-3">
// //                     <div className="col-6">
// //                       <label className="form-label text-muted small fw-bold">PROPOSED DATE</label>
// //                       <input type="date" name="travelDate" className="form-control" value={values.travelDate} onChange={handleInputChange} required />
// //                     </div>
// //                     <div className="col-6">
// //                       <label className="form-label text-muted small fw-bold">TEAM SIZE (PAX)</label>
// //                       <input type="number" name="teamSize" className="form-control" value={values.teamSize} onChange={handleInputChange} placeholder="e.g. 50" required />
// //                     </div>
// //                   </div>
// //                   <div className="mb-4">
// //                     <label className="form-label text-muted small fw-bold text-uppercase">Requirements</label>
// //                     <textarea name="requirement" className="form-control" rows="4" value={values.requirement} onChange={handleInputChange} placeholder="Mention meals, activities, etc..."></textarea>
// //                   </div>
// //                   <div className="hstack gap-2 justify-content-end">
// //                     <button type="button" className="btn btn-light" onClick={handleAddClose}>Discard</button>
// //                     <button type="submit" className="btn btn-primary px-4 fw-bold shadow" disabled={btnLoading}>
// //                       {btnLoading ? "Processing..." : "Create Inquiry"}
// //                     </button>
// //                   </div>
// //                 </form>
// //               </div>

// //               {/* PREVIEW SIDE */}
// //               <div className="col-md-5 bg-light p-4 d-flex flex-column align-items-center justify-content-center border-start">
// //                 <p className="text-muted small fw-bold mb-3 text-uppercase">Inquiry Preview</p>
// //                 <div className="card shadow-sm border-0 w-100 overflow-hidden" style={{ borderRadius: '15px' }}>
// //                     <div className="bg-primary p-3 text-center">
// //                         <i className="ri-ticket-2-line text-white fs-24"></i>
// //                         <h6 className="text-white mb-0 mt-1 fw-bold">Corporate Outing Ticket</h6>
// //                     </div>
// //                     <div className="card-body bg-white py-3 border-bottom border-dashed border-2">
// //                         <small className="text-muted d-block mb-1 text-uppercase">Destination</small>
// //                         <h5 className="fw-bold text-primary mb-3 text-truncate">{values.destination || "Location..."}</h5>
// //                         <div className="row">
// //                             <div className="col-6">
// //                                 <small className="text-muted d-block text-uppercase">Trip Date</small>
// //                                 <span className="fw-bold small">{values.travelDate || "--/--/----"}</span>
// //                             </div>
// //                             <div className="col-6 text-end">
// //                                 <small className="text-muted d-block text-uppercase">Team Size</small>
// //                                 <span className="fw-bold small">{values.teamSize || "0"} Pax</span>
// //                             </div>
// //                         </div>
// //                     </div>
// //                     <div className="p-3 bg-white" style={{ minHeight: '80px' }}>
// //                         <small className="fw-bold text d-block mb-1 text-uppercase">Requirement</small>
// //                         <p className="small text mb-0">{values.requirement || "Describe event needs..."}</p>
// //                     </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </Modal.Body>
// //         </Modal>

// //         {/* FULL REQUIREMENT VIEW MODAL */}
// //         <Modal show={reqShow} onHide={() => setReqShow(false)} centered>
// //           <Modal.Header closeButton>
// //             <Modal.Title className="fs-15 fw-bold">Full Client Requirements</Modal.Title>
// //           </Modal.Header>
// //           <Modal.Body className="bg-light">
// //              <div className="p-3 bg-white border rounded shadow-sm">
// //                 <p className="mb-0" style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
// //                   {reqContent}
// //                 </p>
// //              </div>
// //           </Modal.Body>
// //         </Modal>

// //       </div>
// //     </div>
// //   );
// // };

// // export default TeamOutingRequest;



// import React, { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom"; 
// import config from "../../../Common/Configurations/APIConfig";
// import apiService from "../../../Common/Configurations/APIService";
// import Header from "../../../Common/Layout/Header";
// import { useAuth } from "../../../Common/Configurations/AuthContext";
// import Modal from "react-bootstrap/Modal";
// import OutingChat from "./OutingChat"; 
// import DefaultData from "../../../CompanyData/DefaultData";
// import CorporateTabs from "../../AllTabs/CorporateTabs";

// const initialFieldValues = {
//   outingId: "00000000-0000-0000-0000-000000000000",
//   destination: "",
//   travelDate: new Date().toISOString().split('T')[0],
//   teamSize: "",
//   requirement: "",
// };

// const TeamOutingRequest = () => {
//   const { user, loading } = useAuth();
//   const navigate = useNavigate();

//   const [btnLoading, setBtnLoading] = useState(false);
//   const [lists, setLists] = useState([]);
//   const [values, setValues] = useState(initialFieldValues);
//   const [errors, setErrors] = useState({});
//   const [addShow, setAddShow] = useState(false);
  
//   // --- Filter States ---
//   const [filterStatus, setFilterStatus] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [filterCompanyId, setFilterCompanyId] = useState(""); // Guid filter

//   // Requirement Pop-up States
//   const [reqShow, setReqShow] = useState(false);
//   const [reqContent, setReqContent] = useState("");

//   const [totalPages, setTotalPages] = useState(0);
//   const [pageSize, setPageSize] = useState(10); // Changed to 10 for better pagination view
//   const [pageNumber, setPageNumber] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [selectedOuting, setSelectedOuting] = useState(null); 

//   // --- Fetch Data Logic ---
//   const GetData = async (pageNo = 1) => {
//     try {
//       // 1. Start with base URL and ParentCompanyId
//       let url = `${config.GETOUTINGSBYPARENTCOMPANYID}?parentCompanyId=${DefaultData.DEFAULTCOMPANYID}`;

//       // 2. Append Optional Filters
//       if (filterStatus) url += `&status=${filterStatus}`;
//       if (fromDate) url += `&fromDate=${fromDate}`;
//       if (toDate) url += `&toDate=${toDate}`;
//       if (filterCompanyId) url += `&companyId=${filterCompanyId}`;

//       // 3. Call API with pagination
//       const res = await apiService.getAll(url, pageSize, pageNo);
      
//       if (res && res.data) {
//         setLists(res.data);
//         setPageNumber(res.pageNumber);
//         setTotalPages(res.totalPages);
//         setTotalRecords(res.totalRecords);
//       } else {
//         setLists([]);
//       }
//     } catch (error) { 
//         console.error("Error fetching outings:", error); 
//         setLists([]);
//     }
//   };

//   const handleReset = () => {
//     setFilterStatus("");
//     setFromDate("");
//     setToDate("");
//     setFilterCompanyId("");
//     // We can't immediately call GetData here because state updates are async, 
//     // so we pass the clean values or let the useEffect handle it if we added dependencies.
//     // For now, let's manually trigger a clean fetch:
//     setPageNumber(1);
//     GetData(1); 
//   };

//   useEffect(() => { 
//     if (user && !loading) GetData(pageNumber); 
//   }, [user, loading]); // Remove pageNumber from here if you want to trigger manually

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setValues({ ...values, [name]: value });
//   };

//   const handleSelectOuting = (item) => setSelectedOuting(item);

//   const handleShowFullRequirement = (e, text) => {
//     e.stopPropagation();
//     setReqContent(text);
//     setReqShow(true);
//   };

//   const handleAddShow = () => {
//     setValues(initialFieldValues);
//     setAddShow(true);
//   };

//   const handleAddClose = () => { setAddShow(false); setErrors({}); };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setBtnLoading(true);
//     const payload = { ...values, companyId: user?.cid, userId: user?.id, status: "Pending", outingId: "00000000-0000-0000-0000-000000000000" };
//     try {
//       await apiService.create(config.CREATEOUTING, payload);
//       GetData(1);
//       handleAddClose();
//     } finally { setBtnLoading(false); }
//   };

//   if (loading) return <p>Loading ...</p>;

//   return (
//     <div id="layout-wrapper">
//       <Header User={user} />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             <div className="p-2">
//               <CorporateTabs pageName="OUTINGREQUEST" />
//             </div>

//             {/* HEADER BANNER */}
//             <div className="p-4 mb-4 shadow-sm" style={{ background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)', borderRadius: '15px' }}>
//                 <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
//                     <div>
//                         <h2 className="text-white fw-bold mb-1">Corporate Outing Management</h2>
//                         <p className="text-white-50 fs-14 mb-0">Total Records Found: <span className="text-warning fw-bold">{totalRecords}</span></p>
//                     </div>
//                     <button className="btn btn-warning px-4 fw-bold shadow" onClick={handleAddShow}>
//                         <i className="ri-add-circle-line me-1"></i> LOG NEW INQUIRY
//                     </button>
//                 </div>
//             </div>

//             {/* FILTER SECTION */}
//             <div className="card border-0 shadow-sm mb-4">
//               <div className="card-body">
//                 <div className="row g-3 align-items-end">
//                   <div className="col-md-2">
//                     <label className="form-label small fw-bold text-muted">STATUS</label>
//                     <select className="form-select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
//                       <option value="">All Status</option>
//                       <option value="Pending">Pending</option>
//                       <option value="Confirmed">Confirmed</option>
//                       <option value="Cancelled">Cancelled</option>
//                     </select>
//                   </div>
//                   <div className="col-md-3">
//                     <label className="form-label small fw-bold text-muted">FROM DATE</label>
//                     <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//                   </div>
//                   <div className="col-md-3">
//                     <label className="form-label small fw-bold text-muted">TO DATE</label>
//                     <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
//                   </div>
//                   <div className="col-md-4 text-end">
//                     <button className="btn btn-primary px-4 me-2" onClick={() => { setPageNumber(1); GetData(1); }}>
//                       <i className="ri-search-line me-1"></i> Search
//                     </button>
//                     <button className="btn btn-soft-danger px-4" onClick={handleReset}>
//                       <i className="ri-refresh-line me-1"></i> Reset
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="row">
//                 <div className={selectedOuting ? "col-lg-8" : "col-lg-12"}>
//                     <div className="card border-0 shadow-sm overflow-hidden">
//                         <div className="table-responsive">
//                             <table className="table align-middle mb-0 table-hover">
//                                 <thead className="table-light text-uppercase fs-11">
//                                     <tr>
//                                         <th>Company Name</th>
//                                         <th>Destination</th>
//                                         <th>Pax</th>
//                                         <th>Travel Date</th>
//                                         <th>Status</th>
//                                         <th className="text-center">Action</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {lists.length > 0 ? lists.map((item, i) => (
//                                         <tr key={i} 
//                                             onClick={() => handleSelectOuting(item)} 
//                                             style={{ cursor: 'pointer' }}
//                                             className={selectedOuting?.outingId === item.outingId ? "table-active border-start border-primary border-4" : ""}
//                                         >
//                                             <td><div className="fw-bold text-dark">{item.companyName}</div></td>
//                                             <td className="fw-bold text-primary">{item.destination}</td>
//                                             <td><span className="badge bg-light text-dark border">{item.teamSize} pax</span></td>
//                                             <td>{new Date(item.travelDate).toLocaleDateString('en-GB')}</td>
//                                             <td>
//                                                 <span className={`badge rounded-pill ${item.status === 'Pending' ? 'bg-soft-warning text-warning' : 'bg-soft-success text-success'}`}>
//                                                     {item.status}
//                                                 </span>
//                                             </td>
//                                             <td className="text-center">
//                                                 <div className="d-flex justify-content-center gap-2">
//                                                     <button className="btn btn-sm btn-soft-info" onClick={(e) => handleShowFullRequirement(e, item.requirement)}>
//                                                         <i className="ri-eye-line"></i>
//                                                     </button>
//                                                     <button className={`btn btn-sm ${selectedOuting?.outingId === item.outingId ? 'btn-primary' : 'btn-soft-success'}`} onClick={(e) => { e.stopPropagation(); handleSelectOuting(item); }}>
//                                                         <i className="ri-chat-3-line"></i>
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     )) : (
//                                       <tr><td colSpan="6" className="text-center py-4 text-muted">No records found for the selected filters.</td></tr>
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
                        
//                         <div className="card-footer bg-white border-top p-3">
//                             <div className="d-flex justify-content-between align-items-center">
//                                 <p className="text-muted mb-0 small">Showing {lists.length} of {totalRecords} Records</p>
//                                 <ul className="pagination pagination-sm mb-0">
//                                     <li className={`page-item ${pageNumber === 1 ? 'disabled' : ''}`}><button className="page-link" onClick={() => GetData(pageNumber - 1)}>Prev</button></li>
//                                     <li className="page-item active"><span className="page-link">{pageNumber}</span></li>
//                                     <li className={`page-item ${pageNumber === totalPages ? 'disabled' : ''}`}><button className="page-link" onClick={() => GetData(pageNumber + 1)}>Next</button></li>
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {selectedOuting && (
//                     <div className="col-lg-4">
//                         <OutingChat outing={selectedOuting} user={user} senderType="Support" onClose={() => setSelectedOuting(null)} />
//                     </div>
//                 )}
//             </div>
//           </div>
//         </div>
//                {/* LOG MANUAL REQUEST MODAL (B2E Style) */}
//         <Modal show={addShow} onHide={handleAddClose} centered size="lg" backdrop="static">           <Modal.Header closeButton className="bg-light border-0 px-4">
//              <Modal.Title className="fw-bold fs-18">Log Manual Inquiry</Modal.Title>           </Modal.Header>
//           <Modal.Body className="p-0">
//             <div className="row g-0">
//                {/* FORM SIDE */}
//                <div className="col-md-7 p-4 border-end">
//                  <form onSubmit={handleSubmit}>
//                    <div className="mb-3">
//                     <label className="form-label text-muted small fw-bold">DESTINATION / RESORT</label>
//                     <input type="text" name="destination" className="form-control" value={values.destination} onChange={handleInputChange} placeholder="E.g. Luxury Palms Resort, Goa" required />
//                   </div>
//                   <div className="row mb-3">
//                     <div className="col-6">
//                       <label className="form-label text-muted small fw-bold">PROPOSED DATE</label>
//                       <input type="date" name="travelDate" className="form-control" value={values.travelDate} onChange={handleInputChange} required />
//                     </div>
//                    <div className="col-6">
//                      <label className="form-label text-muted small fw-bold">TEAM SIZE (PAX)</label>
//                      <input type="number" name="teamSize" className="form-control" value={values.teamSize} onChange={handleInputChange} placeholder="e.g. 50" required />
//                     </div>
//                   </div>
//                   <div className="mb-4">
//                     <label className="form-label text-muted small fw-bold text-uppercase">Requirements</label>
//                     <textarea name="requirement" className="form-control" rows="4" value={values.requirement} onChange={handleInputChange} placeholder="Mention meals, activities, etc..."></textarea>
//                   </div>
//                    <div className="hstack gap-2 justify-content-end">
//                     <button type="button" className="btn btn-light" onClick={handleAddClose}>Discard</button>
//                     <button type="submit" className="btn btn-primary px-4 fw-bold shadow" disabled={btnLoading}>
//                       {btnLoading ? "Processing..." : "Create Inquiry"}
//                     </button>
//                   </div>
//                 </form>
//               </div>

//               {/* PREVIEW SIDE */}
//               <div className="col-md-5 bg-light p-4 d-flex flex-column align-items-center justify-content-center border-start">
//                 <p className="text-muted small fw-bold mb-3 text-uppercase">Inquiry Preview</p>                 <div className="card shadow-sm border-0 w-100 overflow-hidden" style={{ borderRadius: '15px' }}>
//                     <div className="bg-primary p-3 text-center">
//                          <i className="ri-ticket-2-line text-white fs-24"></i>
//                        <h6 className="text-white mb-0 mt-1 fw-bold">Corporate Outing Ticket</h6>
//                     </div>
// /                    <div className="card-body bg-white py-3 border-bottom border-dashed border-2">
//                          <small className="text-muted d-block mb-1 text-uppercase">Destination</small>
//                          <h5 className="fw-bold text-primary mb-3 text-truncate">{values.destination || "Location..."}</h5>
//                          <div className="row">
//                              <div className="col-6">
//                                  <small className="text-muted d-block text-uppercase">Trip Date</small>
//                                  <span className="fw-bold small">{values.travelDate || "--/--/----"}</span>
//                              </div>
//                              <div className="col-6 text-end">
//                                  <small className="text-muted d-block text-uppercase">Team Size</small>
//                                  <span className="fw-bold small">{values.teamSize || "0"} Pax</span>
//                              </div>
//                          </div>
//                      </div>
//                      <div className="p-3 bg-white" style={{ minHeight: '80px' }}>
//                          <small className="fw-bold text d-block mb-1 text-uppercase">Requirement</small>
//                          <p className="small text mb-0">{values.requirement || "Describe event needs..."}</p>
//                      </div>
//                  </div>
//                </div>
//              </div>           </Modal.Body>
//         </Modal>

//         {/* FULL REQUIREMENT VIEW MODAL */}
//         <Modal show={reqShow} onHide={() => setReqShow(false)} centered>           <Modal.Header closeButton>
//             <Modal.Title className="fs-15 fw-bold">Full Client Requirements</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="bg-light">
//               <div className="p-3 bg-white border rounded shadow-sm">
//                 <p className="mb-0" style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
//                    {reqContent}
//                  </p>
//               </div>
//            </Modal.Body>
//          </Modal>

//        </div>
//      </div>
//   );
// };

// export default TeamOutingRequest;


import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom"; 
import config from "../../../Common/Configurations/APIConfig";
import apiService from "../../../Common/Configurations/APIService";
import Header from "../../../Common/Layout/Header";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import OutingChat from "./OutingChat"; 
import DefaultData from "../../../CompanyData/DefaultData";
import CorporateTabs from "../../../Components/AllTabs/CorporateTabs"

const initialFieldValues = {
  outingId: "00000000-0000-0000-0000-000000000000",
  destination: "",
  travelDate: new Date().toISOString().split('T')[0],
  teamSize: "",
  requirement: "",
};

const TeamOutingRequest = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [companyList, setCompanyList] = useState([]); // State for Company Dropdown
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [addShow, setAddShow] = useState(false);
  
  // --- Filter States ---
  const [filterStatus, setFilterStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filterCompanyId, setFilterCompanyId] = useState(""); 

  // Requirement Pop-up States
  const [reqShow, setReqShow] = useState(false);
  const [reqContent, setReqContent] = useState("");

  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10); 
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedOuting, setSelectedOuting] = useState(null); 

  // --- Fetch Company List for Dropdown ---
  const GetCompanies = async () => {
    try {
        // Using the existing endpoint that fetches companies belonging to a parent
        const res = await apiService.getAll(`${config.GETCORPORATESBYPARENTCOMPANYID}?parentCompanyId=${DefaultData.DEFAULTCOMPANYID}`);
        if (res) {
            setCompanyList(res);
        }
    } catch (error) {
        console.error("Error fetching companies:", error);
    }
  };

  // --- Fetch Data Logic ---
  const GetData = async (pageNo = 1) => {
    try {
      let url = `${config.GETOUTINGSBYPARENTCOMPANYID}?parentCompanyId=${DefaultData.DEFAULTCOMPANYID}`;

      // Append Filters
      if (filterStatus) url += `&status=${filterStatus}`;
      if (fromDate) url += `&fromDate=${fromDate}`;
      if (toDate) url += `&toDate=${toDate}`;
      if (filterCompanyId) url += `&companyId=${filterCompanyId}`; // Pass selected CompanyId to backend

      const res = await apiService.getAll(url, pageSize, pageNo);
      
      if (res && res.data) {
        setLists(res.data);
        setPageNumber(res.pageNumber);
        setTotalPages(res.totalPages);
        setTotalRecords(res.totalRecords);
      } else {
        setLists([]);
        setTotalRecords(0);
      }
    } catch (error) { 
        console.error("Error fetching outings:", error); 
        setLists([]);
    }
  };

  const handleReset = () => {
    setFilterStatus("");
    setFromDate("");
    setToDate("");
    setFilterCompanyId("");
    setPageNumber(1);
    // Directly call GetData with empty params
    const baseUrl = `${config.GETOUTINGSBYPARENTCOMPANYID}?parentCompanyId=${DefaultData.DEFAULTCOMPANYID}`;
    apiService.getAll(baseUrl, pageSize, 1).then(res => {
        if (res && res.data) {
            setLists(res.data);
            setTotalRecords(res.totalRecords);
        }
    });
  };

  useEffect(() => { 
    if (user && !loading) {
        GetData(pageNumber);
        GetCompanies(); // Load companies for the filter
    } 
  }, [user, loading]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleSelectOuting = (item) => setSelectedOuting(item);

  const handleShowFullRequirement = (e, text) => {
    e.stopPropagation();
    setReqContent(text);
    setReqShow(true);
  };

  const handleAddShow = () => {
    setValues(initialFieldValues);
    setAddShow(true);
  };

  const handleAddClose = () => { setAddShow(false); setErrors({}); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    const payload = { ...values, companyId: user?.cid, userId: user?.id, status: "Pending", outingId: "00000000-0000-0000-0000-000000000000" };
    try {
      await apiService.create(config.CREATEOUTING, payload);
      GetData(1);
      handleAddClose();
    } finally { setBtnLoading(false); }
  };

  if (loading) return <p>Loading ...</p>;

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="p-2">
              <CorporateTabs pageName="OUTINGREQUEST" />
            </div>

            {/* HEADER BANNER */}
          <div className="d-flex justify-content-end mb-4">
    <button 
        className="btn btn-warning px-4 fw-bold shadow" 
        onClick={handleAddShow}
    >
        <i className="ri-add-circle-line me-1"></i> LOG NEW INQUIRY
    </button>
</div>


            {/* UPDATED FILTER SECTION WITH COMPANY */}
            <div className="card border-0 shadow-sm mb-4">
              <div className="card-body">
                <div className="row g-3 align-items-end">
                  {/* Company Filter */}
                  <div className="col-md-3">
                    <label className="form-label small fw-bold text-muted text-uppercase">Company</label>
                    <select className="form-select" value={filterCompanyId} onChange={(e) => setFilterCompanyId(e.target.value)}>
                      <option value="">All Companies</option>
                      {companyList.map((comp) => (
                        <option key={comp.companyId} value={comp.companyId}>
                          {comp.companyName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Status Filter */}
                  <div className="col-md-2">
                    <label className="form-label small fw-bold text-muted text-uppercase">Status</label>
                    <select className="form-select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                      <option value="">All Status</option>
                      <option value="Pending">Pending</option>
                      <option value="Confirmed">Confirmed</option>
                      <option value="Cancelled">Cancelled</option>
                    </select>
                  </div>

                  {/* Date Filters */}
                  <div className="col-md-2">
                    <label className="form-label small fw-bold text-muted text-uppercase">From Date</label>
                    <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                  </div>
                  <div className="col-md-2">
                    <label className="form-label small fw-bold text-muted text-uppercase">To Date</label>
                    <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                  </div>

                  {/* Buttons */}
                  <div className="col-md-3 text-end">
                    <button className="btn btn-primary px-3 me-2" onClick={() => { setPageNumber(1); GetData(1); }}>
                      <i className="ri-search-line me-1"></i> Search
                    </button>
                    <button className="btn btn-soft-danger px-3" onClick={handleReset}>
                      <i className="ri-refresh-line me-1"></i> Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
                <div className={selectedOuting ? "col-lg-8" : "col-lg-12"}>
                    <div className="card border-0 shadow-sm overflow-hidden">
                        <div className="table-responsive">
                            <table className="table align-middle mb-0 table-hover">
                                <thead className="table-light text-uppercase fs-11">
                                    <tr>
                                        <th>Company Name</th>
                                        <th>Destination</th>
                                        <th>Pax</th>
                                        <th>Travel Date</th>
                                        <th>Status</th>
                                        <th className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lists.length > 0 ? lists.map((item, i) => (
                                        <tr key={i} 
                                            onClick={() => handleSelectOuting(item)} 
                                            style={{ cursor: 'pointer' }}
                                            className={selectedOuting?.outingId === item.outingId ? "table-active border-start border-primary border-4" : ""}
                                        >
                                            <td><div className="fw-bold text-dark">{item.companyName}</div></td>
                                            <td className="fw-bold text-primary">{item.destination}</td>
                                            <td><span className="badge bg-light text-dark border">{item.teamSize} pax</span></td>
                                            <td>{new Date(item.travelDate).toLocaleDateString('en-GB')}</td>
                                            <td>
                                                <span className={`badge rounded-pill ${item.status === 'Pending' ? 'bg-soft-warning text-warning' : 'bg-soft-success text-success'}`}>
                                                    {item.status}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex justify-content-center gap-2">
                                                    <button className="btn btn-sm btn-soft-info" onClick={(e) => handleShowFullRequirement(e, item.requirement)}>
                                                        <i className="ri-eye-line"></i>
                                                    </button>
                                                    <button className={`btn btn-sm ${selectedOuting?.outingId === item.outingId ? 'btn-primary' : 'btn-soft-success'}`} onClick={(e) => { e.stopPropagation(); handleSelectOuting(item); }}>
                                                        <i className="ri-chat-3-line"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : (
                                      <tr><td colSpan="6" className="text-center py-4 text-muted">No records found for the selected filters.</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        
                        <div className="card-footer bg-white border-top p-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <p className="text-muted mb-0 small">Showing {lists.length} of {totalRecords} Records</p>
                                <ul className="pagination pagination-sm mb-0">
                                    <li className={`page-item ${pageNumber === 1 ? 'disabled' : ''}`}><button className="page-link" onClick={() => GetData(pageNumber - 1)}>Prev</button></li>
                                    <li className="page-item active"><span className="page-link">{pageNumber}</span></li>
                                    <li className={`page-item ${pageNumber === totalPages ? 'disabled' : ''}`}><button className="page-link" onClick={() => GetData(pageNumber + 1)}>Next</button></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {selectedOuting && (
                    <div className="col-lg-4">
                        <OutingChat outing={selectedOuting} user={user} senderType="Support" onClose={() => setSelectedOuting(null)} />
                    </div>
                )}
            </div>
          </div>
        </div>

        {/* MODALS SECTION */}
        <Modal show={addShow} onHide={handleAddClose} centered size="lg" backdrop="static">
          <Modal.Header closeButton className="bg-light border-0 px-4">
            <Modal.Title className="fw-bold fs-18">Log Manual Inquiry</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <div className="row g-0">
              <div className="col-md-7 p-4 border-end">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label text-muted small fw-bold">DESTINATION / RESORT</label>
                    <input type="text" name="destination" className="form-control" value={values.destination} onChange={handleInputChange} placeholder="E.g. Luxury Palms Resort, Goa" required />
                  </div>
                  <div className="row mb-3">
                    <div className="col-6">
                      <label className="form-label text-muted small fw-bold">PROPOSED DATE</label>
                      <input type="date" name="travelDate" className="form-control" value={values.travelDate} onChange={handleInputChange} required />
                    </div>
                    <div className="col-6">
                      <label className="form-label text-muted small fw-bold">TEAM SIZE (PAX)</label>
                      <input type="number" name="teamSize" className="form-control" value={values.teamSize} onChange={handleInputChange} placeholder="e.g. 50" required />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="form-label text-muted small fw-bold text-uppercase">Requirements</label>
                    <textarea name="requirement" className="form-control" rows="4" value={values.requirement} onChange={handleInputChange} placeholder="Mention meals, activities, etc..."></textarea>
                  </div>
                  <div className="hstack gap-2 justify-content-end">
                    <button type="button" className="btn btn-light" onClick={handleAddClose}>Discard</button>
                    <button type="submit" className="btn btn-primary px-4 fw-bold shadow" disabled={btnLoading}>
                      {btnLoading ? "Processing..." : "Create Inquiry"}
                    </button>
                  </div>
                </form>
              </div>

              <div className="col-md-5 bg-light p-4 d-flex flex-column align-items-center justify-content-center border-start">
                <p className="text-muted small fw-bold mb-3 text-uppercase">Inquiry Preview</p>
                <div className="card shadow-sm border-0 w-100 overflow-hidden" style={{ borderRadius: '15px' }}>
                    <div className="bg-primary p-3 text-center">
                        <i className="ri-ticket-2-line text-white fs-24"></i>
                        <h6 className="text-white mb-0 mt-1 fw-bold">Corporate Outing Ticket</h6>
                    </div>
                    <div className="card-body bg-white py-3 border-bottom border-dashed border-2">
                        <small className="text-muted d-block mb-1 text-uppercase">Destination</small>
                        <h5 className="fw-bold text-primary mb-3 text-truncate">{values.destination || "Location..."}</h5>
                        <div className="row">
                            <div className="col-6">
                                <small className="text-muted d-block text-uppercase">Trip Date</small>
                                <span className="fw-bold small">{values.travelDate || "--/--/----"}</span>
                            </div>
                            <div className="col-6 text-end">
                                <small className="text-muted d-block text-uppercase">Team Size</small>
                                <span className="fw-bold small">{values.teamSize || "0"} Pax</span>
                            </div>
                        </div>
                    </div>
                    <div className="p-3 bg-white" style={{ minHeight: '80px' }}>
                        <small className="fw-bold text d-block mb-1 text-uppercase">Requirement</small>
                        <p className="small text mb-0">{values.requirement || "Describe event needs..."}</p>
                    </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={reqShow} onHide={() => setReqShow(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title className="fs-15 fw-bold">Full Client Requirements</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-light">
             <div className="p-3 bg-white border rounded shadow-sm">
                <p className="mb-0" style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
                  {reqContent}
                </p>
             </div>
          </Modal.Body>
        </Modal>

      </div>
    </div>
  );
};

export default TeamOutingRequest;